import { useEffect, useRef } from 'react';

/**
 * A custom React hook that avoids executing a callback on the first render.
 *
 * @param {Function} callback - The function to be executed after the first render.
 * @param {Array} dependencies - An array of dependencies that trigger the effect when changed.
 * @returns {void} This hook doesn't return anything.
 */
const useAvoidFirstRender = (callback, dependencies) => {
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) callback();
    else isMounted.current = true;
  }, dependencies);
};

// eslint-disable-next-line import/prefer-default-export
export { useAvoidFirstRender };
